import React, { useState, useEffect, useCallback } from 'react';
import { useSwipe } from '../utils/useSwipe';
import { apiFetch } from '../utils/api';

const TABS = ['💰 Net Worth', '📈 Retirement', '💳 Debt', '🎯 Contributions'];

const HISTORY = [
  { date: '2020-01-07', total: 471277 },
  { date: '2020-06-05', total: 469568 },
  { date: '2020-07-07', total: 469557 },
  { date: '2020-10-25', total: 512147 },
  { date: '2020-12-24', total: 558339 },
  { date: '2021-01-04', total: 415581 },
  { date: '2021-04-15', total: 553966 },
  { date: '2021-05-24', total: 553573 },
  { date: '2021-07-07', total: 563327 },
  { date: '2021-08-04', total: 563274 },
  { date: '2021-09-03', total: 575619 },
  { date: '2021-10-05', total: 552031 },
  { date: '2021-11-28', total: 550660 },
  { date: '2022-01-29', total: 455865 },
  { date: '2022-08-14', total: 431956 },
  { date: '2022-11-18', total: 416772 },
  { date: '2023-01-24', total: 353350 },
  { date: '2023-09-17', total: 366094 },
  { date: '2024-01-09', total: 398843 },
  { date: '2024-02-06', total: 402879 },
  { date: '2024-04-05', total: 433583 },
  { date: '2024-05-01', total: 422218 },
  { date: '2024-06-17', total: 446766 },
  { date: '2024-07-01', total: 453513 },
  { date: '2024-08-01', total: 459427 },
  { date: '2024-09-14', total: 472695 },
  { date: '2024-10-03', total: 479072 },
  { date: '2024-11-02', total: 476934 },
  { date: '2024-12-01', total: 516040 },
  { date: '2025-01-01', total: 470410 },
  { date: '2025-02-02', total: 483686 },
  { date: '2025-03-01', total: 481693 },
  { date: '2025-04-13', total: 449625 },
  { date: '2025-05-03', total: 475999 },
  { date: '2025-06-01', total: 488887 },
  { date: '2025-07-02', total: 511366 },
  { date: '2025-08-02', total: 511461 },
  { date: '2025-08-31', total: 532562 },
  { date: '2025-09-30', total: 545742 },
  { date: '2025-10-31', total: 551351 },
  { date: '2025-12-10', total: 557549 },
  { date: '2026-01-01', total: 560537 },
  { date: '2026-02-01', total: 573512 },
  { date: '2026-03-02', total: 582116 },
];

const ACCOUNTS_MARCH_2026 = [
  { name: 'Josh Fed Thrift (Alight)',             balance: 229705.39, owner: 'Josh',  type: 'retirement' },
  { name: 'Josh Roth IRA (eTrade)',               balance: 45000.64,  owner: 'Josh',  type: 'retirement' },
  { name: 'Jenny Roth IRA (eTrade)',              balance: 44737.01,  owner: 'Jenny', type: 'retirement' },
  { name: 'Josh/Jenny Brokerage (eTrade)',        balance: 23181.12,  owner: 'Joint', type: 'brokerage'  },
  { name: 'Jenny MN DCP',                         balance: 4552.94,   owner: 'Jenny', type: 'retirement' },
  { name: 'Josh Upswing 401K (Ascensus)',         balance: 32231.52,  owner: 'Josh',  type: 'retirement' },
  { name: 'Jenny Theraplay (Pacific Life)',       balance: 8399.65,   owner: 'Jenny', type: 'retirement' },
  { name: 'Jenny Alice (Equitable)',              balance: 32121.28,  owner: 'Jenny', type: 'retirement' },
  { name: 'Jenny Fairview (Fidelity)',            balance: 72313.76,  owner: 'Jenny', type: 'retirement' },
  { name: 'Jenny (Valic/AIGRS)',                  balance: 55925.16,  owner: 'Jenny', type: 'retirement' },
  { name: 'Jenny People Inc (Lincoln Financial)', balance: 13144.44,  owner: 'Jenny', type: 'retirement' },
  { name: 'Jenny Thrivent',                       balance: 13939.58,  owner: 'Jenny', type: 'retirement' },
  { name: 'Acorns',                               balance: 2802.23,   owner: 'Joint', type: 'other'      },
  { name: 'Prosper',                              balance: 724.33,    owner: 'Joint', type: 'other'      },
  { name: 'Coinbase',                             balance: 5636.90,   owner: 'Joint', type: 'crypto'     },
];

const typeColors  = { retirement: '#2C7A4B', brokerage: '#3A6FA8', crypto: '#B8922A', other: '#888' };
const typeLabels  = { retirement: 'Retirement', brokerage: 'Brokerage', crypto: 'Crypto', other: 'Other' };
const typeBg      = { retirement: '#EEF7F2', brokerage: '#EDF2F8', crypto: '#FBF6EA', other: '#F5F5F5' };
const typeBorder  = { retirement: '#2C7A4B33', brokerage: '#3A6FA833', crypto: '#B8922A33', other: '#88888833' };

const fmt      = v => '$' + Math.round(v).toLocaleString();
const fmtExact = v => '$' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const fmtDiff  = v => (v >= 0 ? '+' : '') + '$' + Math.abs(Math.round(v)).toLocaleString();

const card = (extra = {}) => ({
  background: 'white', borderRadius: 12, border: '1px solid #EBEBEB',
  padding: '20px 24px', ...extra
});

const pillBtn = (active) => ({
  padding: '6px 16px', borderRadius: 99, border: 'none', cursor: 'pointer',
  fontSize: 13, fontWeight: 600, fontFamily: 'inherit',
  background: active ? '#172A3A' : '#F0F0F0',
  color: active ? 'white' : '#666',
  transition: 'all 0.15s',
});

const sectionLabel = {
  fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
  textTransform: 'uppercase', color: '#aaa', marginBottom: 16,
};

function MiniChart({ data, color = '#2C7A4B' }) {
  if (!data || data.length < 2) return null;
  const vals = data.map(d => d.total);
  const min = Math.min(...vals) * 0.95;
  const max = Math.max(...vals) * 1.02;
  const w = 600, h = 120;
  const pts = data.map((d, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((d.total - min) / (max - min)) * h;
    return `${x},${y}`;
  });
  const area = `M${pts.join(' L')} L${w},${h} L0,${h} Z`;
  const line = `M${pts.join(' L')}`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{ width: '100%', height: 100, display: 'block' }}>
      <defs>
        <linearGradient id="ag" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0.02" />
        </linearGradient>
      </defs>
      <path d={area} fill="url(#ag)" />
      <path d={line} fill="none" stroke={color} strokeWidth="2" />
    </svg>
  );
}

function NetWorthTab({ data, updateData }) {
  const [ownerFilter, setOwnerFilter] = useState('All');
  const [editIdx,     setEditIdx]     = useState(null);
  const [editVal,     setEditVal]     = useState('');

  const accounts = data.accounts || ACCOUNTS_MARCH_2026;
  const filtered  = ownerFilter === 'All' ? accounts : accounts.filter(a => a.owner === ownerFilter);
  const total     = accounts.reduce((s, a) => s + parseFloat(a.balance || 0), 0);
  const history   = data.netWorthHistory || HISTORY;
  const prev      = history.length >= 2 ? history[history.length - 2].total : total;
  const change    = total - prev;
  const byType    = accounts.reduce((acc, a) => { acc[a.type] = (acc[a.type] || 0) + a.balance; return acc; }, {});

  const saveEdit = (idx) => {
    const val = parseFloat(editVal.replace(/[^0-9.]/g, ''));
    if (isNaN(val)) { setEditIdx(null); return; }
    const updated = [...accounts];
    updated[idx] = { ...updated[idx], balance: val };
    const newTotal = updated.reduce((s, a) => s + parseFloat(a.balance || 0), 0);
    const newHistory = [...history, { date: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0], total: newTotal }];
    updateData('accounts', updated);
    updateData('netWorthHistory', newHistory);
    setEditIdx(null);
  };

  return (
    <div style={{ padding: '0 0 40px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gap: 16, alignItems: 'start', marginBottom: 32 }}>
        <div>
          <div style={{ fontSize: 56, fontWeight: 800, lineHeight: 1, color: '#2C7A4B', marginBottom: 4 }}>
            {fmt(total)}
          </div>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4, color: change >= 0 ? '#2C7A4B' : '#B02A2A' }}>
            {fmtDiff(change)} since last update
          </div>
          <div style={{ fontSize: 12, color: '#aaa' }}>
            {history[history.length - 1]?.date}
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 12, paddingTop: 6 }}>
          {Object.entries(byType).map(([type, val]) => (
            <div key={type} style={{
              background: typeBg[type] || '#F5F5F5',
              border: `1.5px solid ${typeBorder[type] || '#88888833'}`,
              borderRadius: 10, padding: '12px 14px'
            }}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: typeColors[type] || '#888', marginBottom: 4 }}>
                {typeLabels[type] || type}
              </div>
              <div style={{ fontSize: 18, fontWeight: 800, color: typeColors[type] || '#888', lineHeight: 1, marginBottom: 2 }}>
                {fmt(val)}
              </div>
              <div style={{ fontSize: 11, color: '#aaa' }}>
                {((val / total) * 100).toFixed(0)}% of total
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ ...card(), marginBottom: 24 }}>
        <div style={sectionLabel}>Net Worth History (2020–present)</div>
        <MiniChart data={history} />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#aaa', padding: '4px 20px 14px' }}>
          <span>{history[0]?.date?.slice(0, 7)}</span>
          <span>{history[history.length - 1]?.date?.slice(0, 7)}</span>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {['All', 'Josh', 'Jenny', 'Joint'].map(f => (
          <button key={f} onClick={() => setOwnerFilter(f)} style={pillBtn(ownerFilter === f)}>{f}</button>
        ))}
      </div>

      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #EBEBEB', overflowX: 'auto' }}>
        {filtered.map((acct, i) => {
          const realIdx = accounts.indexOf(acct);
          return (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 20px',
              borderBottom: i < filtered.length - 1 ? '1px solid #F0F0F0' : 'none'
            }}>
              <div>
                <div style={{ fontSize: 14, color: '#172A3A', marginBottom: 2 }}>{acct.name}</div>
                <div style={{ fontSize: 12, color: '#aaa' }}>
                  {acct.owner} ·{' '}
                  <span style={{ color: typeColors[acct.type] || '#888' }}>{typeLabels[acct.type] || acct.type}</span>
                </div>
              </div>
              {editIdx === realIdx ? (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <input autoFocus value={editVal} onChange={e => setEditVal(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') saveEdit(realIdx); if (e.key === 'Escape') setEditIdx(null); }}
                    style={{ width: 110, padding: '4px 8px', borderRadius: 6, border: '1px solid #EBEBEB', fontSize: 14, textAlign: 'right' }} />
                  <button onClick={() => saveEdit(realIdx)} style={{ padding: '4px 10px', borderRadius: 6, border: 'none', background: '#172A3A', color: '#fff', cursor: 'pointer', fontSize: 12 }}>Save</button>
                  <button onClick={() => setEditIdx(null)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #EBEBEB', background: 'white', color: '#aaa', cursor: 'pointer', fontSize: 12 }}>✕</button>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#172A3A' }}>{fmt(acct.balance)}</span>
                  <button onClick={() => { setEditIdx(realIdx); setEditVal(acct.balance.toString()); }}
                    style={{ padding: '3px 10px', borderRadius: 6, border: '1px solid #EBEBEB', background: 'white', color: '#aaa', cursor: 'pointer', fontSize: 12 }}>
                    Edit
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function RetirementTab({ data }) {
  const [rate, setRate] = useState(6);
  const [retData, setRetData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/finance/retirement')
      .then(d => { setRetData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const now = new Date();
  const retirementDate = new Date('2045-04-19');
  const yearsLeft = Math.max(0, (retirementDate - now) / (1000 * 60 * 60 * 24 * 365.25));
  const yearsDisplay = Math.floor(yearsLeft);
  const monthsDisplay = Math.round((yearsLeft - yearsDisplay) * 12);

  const latest = retData?.latest || {};
  const snapshots = retData?.snapshots || [];
  const total = latest.total || 0;

  const fv   = total * Math.pow(1 + rate / 100, yearsLeft);
  const fv6  = total * Math.pow(1.06, yearsLeft);
  const fv10 = total * Math.pow(1.10, yearsLeft);
  const circ = 377;
  const ringPct = total > 0 ? Math.round((total / fv) * 100) : 0;
  const ringOffset = circ - (ringPct / 100) * circ;

  const pension_jenny = latest.pension_jenny || 4487;
  const pension_josh  = latest.pension_josh  || 930;
  const ss_josh       = latest.ss_josh       || 3009;
  const ss_jenny      = latest.ss_jenny      || 3054;
  const pensionTotal  = pension_jenny + pension_josh;
  const ssTotal       = ss_josh + ss_jenny;
  const pensionSS     = pensionTotal + ssTotal;
  const portfolioMonthly = fv * 0.04 / 12;
  const totalMonthly  = portfolioMonthly + pensionSS;

  const historicalPoints = snapshots.map(s => ({ year: s.year, value: s.total }));
  const projectedPoints = [];
  for (let y = 0; y <= 2045 - now.getFullYear(); y++) {
    projectedPoints.push({ year: now.getFullYear() + y, value: total * Math.pow(1 + rate / 100, y) });
  }
  const allPoints = [...historicalPoints, ...projectedPoints];
  const maxVal = Math.max(...allPoints.map(p => p.value));
  const chartH = 70, chartW = 600;

  const toXY = (points) => points.map(p => {
    const minYear = allPoints[0]?.year || 2022;
    const maxYear = 2045;
    const x = ((p.year - minYear) / (maxYear - minYear)) * chartW;
    const y = chartH - (p.value / maxVal) * (chartH - 8) - 4;
    return [x, y];
  });

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#aaa' }}>Loading retirement data…</div>;

  return (
    <div style={{ padding: '0 0 40px' }}>

      {/* HERO: ring + projected number + total income */}
      <div style={{ ...card(), display: 'flex', alignItems: 'center', gap: 20, marginBottom: 16 }}>
        <svg width="150" height="150" viewBox="0 0 150 150" style={{ flexShrink: 0 }}>
          <circle cx="75" cy="75" r="60" fill="none" stroke="#EBEBEB" strokeWidth="11" />
          <circle cx="75" cy="75" r="60" fill="none" stroke="#2C7A4B" strokeWidth="11"
            strokeDasharray={circ} strokeDashoffset={ringOffset}
            strokeLinecap="round"
            style={{ transform: 'rotate(-90deg)', transformOrigin: '75px 75px', transition: 'stroke-dashoffset 0.4s ease' }} />
          <text x="75" y="70" textAnchor="middle" style={{ fontSize: 16, fontWeight: 700, fill: '#172A3A', fontFamily: 'inherit' }}>{ringPct}%</text>
          <text x="75" y="88" textAnchor="middle" style={{ fontSize: 10, fill: '#aaa', fontFamily: 'inherit' }}>to goal</text>
        </svg>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ ...sectionLabel, marginBottom: 4 }}>Projected at {rate}% · April 2045</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#2C7A4B', lineHeight: 1, marginBottom: 10 }}>{fmt(fv)}</div>
          <div style={{ borderTop: '1px solid #F0F0F0', paddingTop: 10, marginBottom: 4 }}>
            <div style={{ ...sectionLabel, marginBottom: 2 }}>Est. income per month at retirement</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: '#172A3A', lineHeight: 1 }}>{fmt(totalMonthly)}<span style={{ fontSize: 12, fontWeight: 400, color: '#aaa' }}>/mo</span></div>
            <div style={{ fontSize: 10, color: '#aaa', marginTop: 3 }}>{fmt(portfolioMonthly)} portfolio + {fmt(pensionSS)} guaranteed</div>
          </div>
        </div>
      </div>

      {/* SLIDER + CHART */}
      <div style={{ ...card({ padding: 0, overflow: 'hidden' }), marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px 8px' }}>
          <div style={{ ...sectionLabel, margin: 0, flexShrink: 0 }}>Annual return</div>
          <input type="range" min={3} max={12} step={0.5} value={rate}
            onChange={e => setRate(parseFloat(e.target.value))}
            style={{ flex: 1, accentColor: '#172A3A' }} />
          <div style={{ fontSize: 16, fontWeight: 800, color: '#172A3A', minWidth: 36, textAlign: 'right' }}>{rate}%</div>
        </div>
        <svg viewBox={"0 0 " + chartW + " " + chartH} style={{ width: '100%', height: chartH, display: 'block', marginBottom: 6 }}>
          <defs>
            <linearGradient id="rg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#2C7A4B" stopOpacity="0.18" />
              <stop offset="100%" stopColor="#2C7A4B" stopOpacity="0.02" />
            </linearGradient>
          </defs>
          {(() => {
            if (allPoints.length < 2) return null;
            const histXY = toXY(historicalPoints);
            const projXY = toXY(projectedPoints);
            const allXY  = toXY(allPoints);
            const areaPath = 'M' + allXY.map(([x,y]) => x+','+y).join(' L') + ' L'+chartW+','+chartH+' L0,'+chartH+' Z';
            const histPath = histXY.length > 1 ? 'M'+histXY.map(([x,y]) => x+','+y).join(' L') : '';
            const projPath = projXY.length > 1 ? 'M'+projXY.map(([x,y]) => x+','+y).join(' L') : '';
            const joinPath = histXY.length > 0 && projXY.length > 0
              ? 'M'+histXY[histXY.length-1][0]+','+histXY[histXY.length-1][1]+' L'+projXY[0][0]+','+projXY[0][1]
              : '';
            return (
              <>
                <path d={areaPath} fill="url(#rg)" />
                {histPath && <path d={histPath} fill="none" stroke="#2C7A4B" strokeWidth="2" />}
                {joinPath && <path d={joinPath} fill="none" stroke="#2C7A4B" strokeWidth="1.5" strokeDasharray="4,3" />}
                {projPath && <path d={projPath} fill="none" stroke="#2C7A4B" strokeWidth="1.5" strokeDasharray="4,3" />}
                {histXY.map(([x, y], i) => (
                  <circle key={i} cx={x} cy={y} r="2.5" fill="#2C7A4B" />
                ))}
              </>
            );
          })()}
        </svg>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#aaa', padding: '0 20px 14px' }}>
          <span>{historicalPoints[0]?.year || now.getFullYear()}</span>
          <span style={{ fontStyle: 'italic' }}>- - projected</span>
          <span>2045</span>
        </div>
      </div>

      {/* SCENARIOS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 16 }}>
        {[
          { label: 'Conservative', sub: '6% return',      fv: fv6,  color: '#B8922A', bg: '#FBF6EA', border: '#B8922A33' },
          { label: 'Your rate',    sub: rate+'% return',  fv,       color: '#2C7A4B', bg: '#EEF7F2', border: '#2C7A4B33' },
          { label: 'Optimistic',   sub: '10% return',     fv: fv10, color: '#3A6FA8', bg: '#EDF2F8', border: '#3A6FA833' },
        ].map(s => (
          <div key={s.label} style={{ background: s.bg, border: '1px solid '+s.border, borderRadius: 10, padding: '12px 10px' }}>
            <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: s.color, marginBottom: 2 }}>{s.label}</div>
            <div style={{ fontSize: 10, color: '#aaa', marginBottom: 8 }}>{s.sub}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: s.color, lineHeight: 1, marginBottom: 4 }}>{fmt(s.fv)}</div>
            <div style={{ fontSize: 10, color: '#888' }}>{fmt(s.fv * 0.04 / 12)}/mo</div>
          </div>
        ))}
      </div>

      {/* TODAY + TIME LEFT */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        <div style={{ background: '#F7F7F7', borderRadius: 10, padding: '12px 14px' }}>
          <div style={{ ...sectionLabel, marginBottom: 4 }}>Current portfolio</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#172A3A' }}>{fmt(total)}</div>
        </div>
        <div style={{ background: '#F7F7F7', borderRadius: 10, padding: '12px 14px' }}>
          <div style={{ ...sectionLabel, marginBottom: 4 }}>Time remaining</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#172A3A' }}>{yearsDisplay}y {monthsDisplay}m</div>
        </div>
      </div>

      {/* GUARANTEED INCOME BREAKDOWN */}
      <div style={{ ...sectionLabel, marginBottom: 10 }}>Guaranteed monthly income breakdown</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div style={{ background: '#EEF7F2', border: '1px solid #2C7A4B33', borderRadius: 10, padding: '12px 14px' }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#2C7A4B', marginBottom: 4 }}>Pension</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#2C7A4B', lineHeight: 1, marginBottom: 4 }}>{fmt(pensionTotal)}</div>
          <div style={{ fontSize: 10, color: '#888' }}>Josh + Jenny combined</div>
        </div>
        <div style={{ background: '#EDF2F8', border: '1px solid #3A6FA833', borderRadius: 10, padding: '12px 14px' }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#3A6FA8', marginBottom: 4 }}>Social Security</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#3A6FA8', lineHeight: 1, marginBottom: 4 }}>{fmt(ssTotal)}</div>
          <div style={{ fontSize: 10, color: '#888' }}>Josh + Jenny combined</div>
        </div>
      </div>

    </div>
  );
}

function DebtTab() {
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch('/api/finance/debt')
      .then(data => { setMonths(data); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  if (loading) return <div style={{ color: '#aaa', padding: 40, textAlign: 'center' }}>Loading debt data...</div>;
  if (error)   return <div style={{ color: '#B02A2A', padding: 40, textAlign: 'center' }}>Error: {error}</div>;
  if (!months.length) return <div style={{ color: '#aaa', padding: 40, textAlign: 'center' }}>No data found.</div>;

  const now = new Date();
  const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  const currentMonthLabel = monthNames[now.getMonth()] + ' ' + now.getFullYear();
  const currentMonthData = months.find(m => m.month === currentMonthLabel) || months.filter(m => {
    const parts = m.month.split(' ');
    const mDate = new Date(parseInt(parts[1]), monthNames.indexOf(parts[0]), 1);
    return mDate <= now;
  }).slice(-1)[0] || months[months.length - 1];
  const currentMonthAllPaid = currentMonthData && currentMonthData.debts.every(d => d.paid);
  const currentMonthIdx = months.indexOf(currentMonthData);
  const current = (currentMonthAllPaid && currentMonthIdx < months.length - 1)
    ? months[currentMonthIdx + 1]
    : currentMonthData;
  const completedMonth = currentMonthAllPaid ? currentMonthData.month : null;
  const currentTotal = current.debts.reduce((s, d) => s + d.balance, 0);
  const currentMin   = current.debts.reduce((s, d) => s + d.minimum, 0);
  const paidCount    = current.debts.filter(d => d.paid).length;

  const prevMonth = months.length >= 2 ? months[currentMonthIdx - 1] : null;
  const prevTotal = prevMonth ? prevMonth.debts.reduce((s, d) => s + d.balance, 0) : currentTotal;
  const change = currentTotal - prevTotal;

  // Payoff calculations from spreadsheet data
  // Only show payoff date if the debt actually reaches zero or disappears in the data
  const allDebtNames = [...new Set(months.flatMap(m => m.debts.map(d => d.name)))];
  const payoffByDebt = {};
  allDebtNames.forEach(name => {
    const sortedMonths = [...months];
    for (let i = 0; i < sortedMonths.length - 1; i++) {
      const thisDebt = sortedMonths[i].debts.find(d => d.name === name);
      const nextDebt = sortedMonths[i + 1].debts.find(d => d.name === name);
      // Paid off if: had balance > 0, then next month is zero OR debt disappears entirely
      if (thisDebt && thisDebt.balance > 0) {
        if (!nextDebt || nextDebt.balance === 0) {
          payoffByDebt[name] = sortedMonths[i + 1].month;
          break;
        }
      }
    }
  });

  // Overall payoff = last month any debt has a balance
  const lastMonthWithAnyDebt = [...months].reverse().find(m =>
    m.debts.some(d => d.balance > 0)
  );
  const payoffMonth = lastMonthWithAnyDebt ? lastMonthWithAnyDebt.month : null;
  const payoffParts = payoffMonth ? payoffMonth.split(' ') : null;
  const payoffDate = payoffParts ? new Date(parseInt(payoffParts[1]), monthNames.indexOf(payoffParts[0]), 1) : null;
  const monthsRemaining = payoffDate ? Math.round((payoffDate - now) / (1000 * 60 * 60 * 24 * 30.44)) : null;
  const yearsRemaining = monthsRemaining ? (monthsRemaining / 12).toFixed(1) : null;

  // Full trend — all historical + projected
  const fullTrendData = months.filter(m => {
    const parts = m.month.split(' ');
    const mDate = new Date(parseInt(parts[1]), monthNames.indexOf(parts[0]), 1);
    return true;
  }).map(m => ({
    label: m.month,
    total: m.debts.reduce((s, d) => s + d.balance, 0),
    isFuture: (() => {
      const parts = m.month.split(' ');
      return new Date(parseInt(parts[1]), monthNames.indexOf(parts[0]), 1) > now;
    })()
  }));

  // Split into past and future for dual-color rendering
  const pastData   = fullTrendData.filter(d => !d.isFuture);
  const futureData = fullTrendData.filter(d => d.isFuture);
  // Add last past point to start of future so lines connect
  if (pastData.length && futureData.length) futureData.unshift(pastData[pastData.length - 1]);

  const chartW = 600, chartH = 120;
  const allVals = fullTrendData.map(d => d.total);
  const minV = Math.min(...allVals) * 0.95;
  const maxV = Math.max(...allVals) * 1.05;
  const totalPoints = fullTrendData.length;

  const toXY = (d, i, arr) => {
    const globalIdx = fullTrendData.indexOf(d);
    const x = (globalIdx / (totalPoints - 1)) * chartW;
    const y = chartH - ((d.total - minV) / (maxV - minV)) * (chartH - 8);
    return { x, y };
  };

  const pastPts   = pastData.map((d, i) => toXY(d, i, pastData));
  const futurePts = futureData.map((d, i) => toXY(d, i, futureData));

  const pastLine   = pastPts.length >= 2   ? 'M' + pastPts.map(p => `${p.x},${p.y}`).join(' L')   : null;
  const futureLine = futurePts.length >= 2 ? 'M' + futurePts.map(p => `${p.x},${p.y}`).join(' L') : null;
  const pastArea   = pastLine   ? pastLine   + ` L${pastPts[pastPts.length-1].x},${chartH} L${pastPts[0].x},${chartH} Z`     : null;
  const futureArea = futureLine ? futureLine + ` L${futurePts[futurePts.length-1].x},${chartH} L${futurePts[0].x},${chartH} Z` : null;

  // Today marker x position
  const todayIdx = fullTrendData.findIndex(d => d.isFuture) - 1;
  const todayX = todayIdx >= 0 ? (todayIdx / (totalPoints - 1)) * chartW : null;

  return (
    <div style={{ padding: '0 0 40px' }}>

      {completedMonth && (
        <div style={{ background: '#EEF7F2', border: '1.5px solid #2C7A4B33', borderRadius: 10, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#2C7A4B', fontWeight: 600 }}>
          ✓ {completedMonth} fully paid — showing {current.month}
        </div>
      )}

      {/* Headline stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 12, marginBottom: 28 }}>
        <div style={{ background: 'white', border: '1px solid #EBEBEB', borderRadius: 10, padding: '14px 18px' }}>
          <div style={sectionLabel}>Current Balance</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#B02A2A', lineHeight: 1, marginBottom: 4 }}>{fmt(currentTotal)}</div>
          <div style={{ fontSize: 12, fontWeight: 600, color: change <= 0 ? '#2C7A4B' : '#B02A2A' }}>
            {change <= 0 ? '▼' : '▲'} {fmt(Math.abs(change))} vs last month
          </div>
        </div>

        <div style={{ background: 'white', border: '1px solid #EBEBEB', borderRadius: 10, padding: '14px 18px' }}>
          <div style={sectionLabel}>Monthly Minimums</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#172A3A', lineHeight: 1, marginBottom: 4 }}>{fmt(currentMin)}</div>
          <div style={{ fontSize: 12, color: '#aaa' }}>{paidCount}/{current.debts.length} paid this month</div>
        </div>
      </div>

      {/* Trend chart — past solid, future dashed */}
      <div style={{ ...card({ padding: 0, overflow: 'hidden' }), marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '16px 20px 8px' }}>
          <div style={sectionLabel}>Debt Payoff Trajectory</div>
          <div style={{ fontSize: 11, color: '#aaa' }}>
            <span style={{ color: '#B02A2A' }}>—</span> actual &nbsp;
            <span style={{ color: '#B02A2A99' }}>- - -</span> projected
          </div>
        </div>
        <svg viewBox={`0 0 ${chartW} ${chartH}`} style={{ width: '100%', height: 110, display: 'block' }}>
          <defs>
            <linearGradient id="dpast" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#B02A2A" stopOpacity="0.2" />
              <stop offset="100%" stopColor="#B02A2A" stopOpacity="0.02" />
            </linearGradient>
            <linearGradient id="dfuture" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#B02A2A" stopOpacity="0.08" />
              <stop offset="100%" stopColor="#B02A2A" stopOpacity="0.01" />
            </linearGradient>
          </defs>
          {pastArea   && <path d={pastArea}   fill="url(#dpast)" />}
          {futureArea && <path d={futureArea} fill="url(#dfuture)" />}
          {pastLine   && <path d={pastLine}   fill="none" stroke="#B02A2A" strokeWidth="2.5" />}
          {futureLine && <path d={futureLine} fill="none" stroke="#B02A2A" strokeWidth="2" strokeDasharray="6,4" strokeOpacity="0.6" />}
          {todayX !== null && <line x1={todayX} y1={0} x2={todayX} y2={chartH} stroke="#172A3A" strokeWidth="1" strokeDasharray="3,3" strokeOpacity="0.3" />}
        </svg>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#aaa', marginTop: 4 }}>
          <span>{fullTrendData[0]?.label}</span>
          <span style={{ color: '#2C7A4B', fontWeight: 600 }}>{payoffMonth}</span>
        </div>
      </div>

      {/* Current month debt list */}
      <div style={sectionLabel}>{current.month} — Individual Balances</div>
      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #EBEBEB', marginBottom: 24 }}>
        {current.debts.filter(d => d.balance > 0 || d.minimum > 0).map((d, i, arr) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '12px 20px',
            borderBottom: i < arr.length - 1 ? '1px solid #F0F0F0' : 'none',
            opacity: d.paid ? 0.5 : 1,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                background: d.paid ? '#2C7A4B' : '#F0F0F0',
                border: `2px solid ${d.paid ? '#2C7A4B' : '#DCDCDC'}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {d.paid && <span style={{ color: 'white', fontSize: 11, fontWeight: 700 }}>✓</span>}
              </div>
              <div>
                <div style={{ fontSize: 14, color: '#172A3A', textDecoration: d.paid ? 'line-through' : 'none' }}>{d.name}</div>
                <div style={{ fontSize: 12, color: '#aaa' }}>
                  Min: {fmtExact(d.minimum)}/mo
                  {(() => {
                    const pm = payoffByDebt[d.name];
                    if (!pm) return null;
                    const parts = pm.split(' ');
                    const pDate = new Date(parseInt(parts[1]), monthNames.indexOf(parts[0]), 1);
                    const moLeft = Math.round((pDate - now) / (1000 * 60 * 60 * 24 * 30.44));
                    if (moLeft <= 0) return null;
                    return <span style={{ marginLeft: 8, color: '#2C7A4B', fontWeight: 600 }}>· {moLeft} months until payoff</span>;
                  })()}
                </div>
              </div>
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: d.paid ? '#aaa' : '#B02A2A' }}>
              {fmt(d.balance)}
            </div>
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 20px', borderTop: '2px solid #F0F0F0' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#172A3A' }}>Total</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#B02A2A' }}>{fmt(currentTotal)}</div>
        </div>
      </div>
    </div>
  );
}

function ContributionsTab({ data }) {
  const contributions = data.contributions || [
    { name: 'Jenny MN Monthly',  monthly: 210.00,  owner: 'Jenny' },
    { name: 'Josh Upswing 401K', monthly: 272.52,  owner: 'Josh'  },
    { name: 'Josh eTrade',       monthly: 173.33,  owner: 'Josh'  },
    { name: 'Jenny eTrade',      monthly: 173.33,  owner: 'Jenny' },
  ];

  const monthly = contributions.reduce((s, c) => s + c.monthly, 0);
  const annual  = monthly * 12;

  const history = [
    { year: 2021, annual: 721.5  * 12 },
    { year: 2022, annual: 721.5  * 12 },
    { year: 2023, annual: 465.18 * 12 },
    { year: 2024, annual: 476.18 * 12 },
    { year: 2025, annual: 829    * 12 },
    { year: 2026, annual: annual       },
  ];
  const maxAnnual = Math.max(...history.map(h => h.annual));

  return (
    <div style={{ padding: '0 0 40px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gap: 16, alignItems: 'start', marginBottom: 32 }}>
        <div>
          <div style={{ fontSize: 56, fontWeight: 800, lineHeight: 1, color: '#3A6FA8', marginBottom: 4 }}>
            {fmtExact(monthly)}
          </div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#3A6FA8', marginBottom: 16 }}>per month</div>
          <div style={{ fontSize: 12, color: '#aaa' }}>{fmtExact(annual)} / year</div>
        </div>
        <div style={{ paddingTop: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 12 }}>
            {contributions.map((c, i) => (
              <div key={i} style={{ background: '#EDF2F8', border: '1.5px solid #3A6FA833', borderRadius: 10, padding: '12px 14px' }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#3A6FA8', marginBottom: 4 }}>{c.owner}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#3A6FA8', lineHeight: 1, marginBottom: 4 }}>{fmtExact(c.monthly)}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{c.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={card()}>
        <div style={sectionLabel}>Annual Contributions by Year</div>
        {history.map(h => {
          const pct = (h.annual / maxAnnual) * 100;
          const isCurrentYear = h.year === new Date().getFullYear();
          return (
            <div key={h.year} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <div style={{ width: 36, fontSize: 12, color: '#aaa', textAlign: 'right' }}>{h.year}</div>
              <div style={{ flex: 1, background: '#F0F0F0', borderRadius: 4, height: 18, overflow: 'hidden' }}>
                <div style={{
                  width: `${pct}%`, height: '100%', borderRadius: 4, transition: 'width 0.5s',
                  background: isCurrentYear ? '#3A6FA8' : '#3A6FA855'
                }} />
              </div>
              <div style={{ width: 80, fontSize: 12, color: isCurrentYear ? '#3A6FA8' : '#888', fontWeight: isCurrentYear ? 700 : 400, textAlign: 'right' }}>
                {fmtExact(h.annual)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Finance({ data, updateData }) {
  const [tabIdx, setTabIdx] = useState(0);
  const [slideDir, setSlideDir] = useState(null);
  const goLeft  = useCallback(() => {
    setSlideDir('left');
    setTabIdx(i => Math.max(0, i - 1));
  }, []);
  const goRight = useCallback(() => {
    setSlideDir('right');
    setTabIdx(i => Math.min(TABS.length - 1, i + 1));
  }, []);
  useSwipe(goRight, goLeft);

  const tab = TABS[tabIdx].replace(/^[^ ]+ /, '');

  const slideStyle = slideDir ? {
    animation: `slideIn${slideDir === 'right' ? 'Left' : 'Right'} 0.25s ease forwards`,
  } : {};

  return (
    <div>
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(40px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(-40px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}} />
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 28 }}>
        {TABS.map((t, i) => (
          <button key={t} onClick={() => { setSlideDir(i > tabIdx ? 'right' : 'left'); setTabIdx(i); }} style={pillBtn(tabIdx === i)}>{t}</button>
        ))}
      </div>
      <div key={tabIdx} style={slideStyle}>
        {tab === 'Net Worth'     && <NetWorthTab      data={data} updateData={updateData} />}
        {tab === 'Retirement'    && <RetirementTab    data={data} />}
        {tab === 'Debt'          && <DebtTab />}
        {tab === 'Contributions' && <ContributionsTab data={data} />}
      </div>
    </div>
  );
}
